import { Minus, TrendingDown, TrendingUp } from 'lucide-react';

import { cn } from '@/lib/utils';

export function HeroStatCard({
  label,
  value,
  delta,
  deltaLabel = 'vs prior period',
  gradient,
}: {
  label: string;
  value: string;
  /** Percent change, or undefined when there's no comparison to show (e.g. "Top item"). */
  delta?: number;
  deltaLabel?: string;
  gradient: string;
}) {
  const DeltaIcon = delta === undefined || delta === 0 ? Minus : delta > 0 ? TrendingUp : TrendingDown;

  return (
    <div className={cn('rounded-2xl p-4 text-white shadow-sm', gradient)}>
      <p className="text-xs text-white/70">{label}</p>
      <p className="tabular mt-1 truncate text-2xl font-bold leading-tight">{value}</p>
      {delta !== undefined ? (
        <p className="mt-1 flex items-center gap-1 text-xs text-white/80">
          <DeltaIcon className="h-3 w-3" />
          {Math.abs(delta)}% {deltaLabel}
        </p>
      ) : (
        <p className="mt-1 text-xs text-white/70">{deltaLabel}</p>
      )}
    </div>
  );
}